module.exports = __webpack_public_path__ + "assets/img/icon-jiqiao.4ff7f774.png";